import * as React from 'react';

import Select, { SelectProps } from 'antd/lib/select';

import { getLabel } from '../lib/get-label';
import { useSelect } from '../lib/use-select';
import { CoreSelectProps } from '../types/props';

import { SelectList } from '@app/store/SelectList/SelectList';
import { SelectRequestParams } from '@app/store/SelectList/ListActions';

/**
 * CoreSelect is a redux-driven base select.
 * Any select that uses data from server should use this component as its basis.
 * @param {CoreSelectProps<TValue, TStore, TParams>} props
 * @returns {React.ReactElement}
 * @constructor
 */
export const CoreSelect = <
	TValue,
	TStore extends keyof SelectList,
	TParams extends SelectRequestParams<number> = SelectRequestParams<number>
>(props: CoreSelectProps<number, TStore, TParams>): React.ReactElement => {
	const properties = useSelect<TStore, TParams>(props);

	return (
		<div className={props.className} style={props.style}>
			{getLabel(props.label)}
			<span className="ant-select-selection__placeholder">{props.placeholder}</span>
			{
				props.multiple
					? <Select<Array<number>> {...(properties as SelectProps<Array<number>>)} />
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					: <Select<TValue> {...(properties as SelectProps<TValue>)} />
			}
		</div>
	);
};
